import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"

const 半田種類 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { solderType: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="半田種類">
      <RadioGroup name={FIELD_NAMES.半田種類} selectedValue={values.solderType} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.半田種類.共晶半田.value}>共晶半田</Radio>
          <Radio value={ESTIMATE_CONSTANT.半田種類.鉛フリー半田.value}>鉛フリー半田</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.solderType} />
    </OneClickField>
  )
}

export default 半田種類
